// extracted by mini-css-extract-plugin
var _1 = "FileMultiValuedListMoreItem-moduletext__uEjbP FileMultiValue-moduletext__ywBLO TableCellText-moduleTableCellText__b5epO";
export { _1 as "text" }
